import { useTranslate } from 'react-polyglot';

import { MoveIcon } from '@genially/icons';

import { ConfigToggle } from '../ConfigToggle/ConfigToggle';

export const RaiseHandToggle = ({
  isEnabled,
  onChange,
}: {
  isEnabled: boolean;
  onChange: () => void;
}) => {
  const t = useTranslate();

  return (
    <ConfigToggle
      Icon={MoveIcon}
      text={t('__new.play.shared.configuration.modal.handsUpSwitch')}
      checked={isEnabled}
      onChange={onChange}
    />
  );
};
